import { useEffect, useState, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { ErrorBoundary } from './ErrorBoundary'
import { EaLicenseAlert } from './EaLicenseAlert'

export function AppShell({ children }: { children: ReactNode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setSidebarOpen(false)
  }, [location.pathname])

  return (
    <div className="flex h-screen overflow-hidden bg-b4l-app">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {/* Expirarea modulelor EA se anunta peste tot, nu doar pe o pagina anume. */}
      <EaLicenseAlert />
      {/* `min-w-0` nu e cosmetic: un copil de flex are implicit `min-width: auto`, adică
          lățimea conținutului. Fără el, o singură pagină cu ceva lat — un tabel, un email cu
          un link lung — umflă coloana asta peste ecran și împinge TOATĂ interfața în lateral,
          bara de sus cu tot. Pe telefon se vedea ca un ecran gol, cu conținutul ieșit din
          cadru. Aici e locul care oprește asta pentru toate paginile deodată. */}
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-auto p-4 md:p-6">
          <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>
        </main>
      </div>
    </div>
  )
}
